import { useEffect } from 'react';

interface KeyboardShortcutHandlers {
  onSave?: () => void;
  onExportExcel?: () => void;
  onExportPDF?: () => void;
  onNewCycle?: () => void;
}

export function useKeyboardShortcuts(handlers: KeyboardShortcutHandlers) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl/Cmd key
      const isModifier = event.ctrlKey || event.metaKey;

      if (!isModifier) return;

      switch (event.key.toLowerCase()) {
        case 's':
          // Ctrl/Cmd + S: Save
          event.preventDefault();
          handlers.onSave?.();
          break;
        case 'e':
          // Ctrl/Cmd + E: Export Excel
          event.preventDefault();
          handlers.onExportExcel?.();
          break;
        case 'p':
          // Ctrl/Cmd + P: Export PDF
          event.preventDefault();
          handlers.onExportPDF?.();
          break;
        case 'n':
          // Ctrl/Cmd + N: New Cycle
          event.preventDefault();
          handlers.onNewCycle?.();
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handlers]);
}
